import * as Immutable from "immutable"

import { AbstractConfigurationMessage } from "./abstractConfigurationMessage"

export class DataSelectorKeyDetailMessage extends AbstractConfigurationMessage {

  protected readonly KEY_ID = "keyId";
  protected readonly DETAILS = "details";

  get keyId(): number { return this.getInternalValue<number>(this.KEY_ID); }
  setKeyId(keyId: number): this { return this.setInternalValue(this.KEY_ID, keyId); }

  /** 
  Key: Parameter ID or MultiChoiceValueID for multichoices.
  Value: Current value.
  */
  get details(): Immutable.Map<string, string> { return this.getInternalValue<Immutable.Map<string, string>>(this.DETAILS); }
  setDetails(details: Immutable.Map<string, string>): this { return this.setInternalValue(this.DETAILS, details); }
}